/**
 * Role-check helpers. The FE never trusts a role check for security
 * — it's a UX affordance. The BE enforces authority on every endpoint;
 * these helpers exist to hide irrelevant surfaces from the wrong
 * audience (e.g. don't show the super-admin tenant panel to a tenant
 * admin) and to redirect away from direct-URL access.
 */

/** Role names the backend persists. Mirrors ``UserRole`` enum. */
export type RoleString = string | null | undefined;

const SUPER_ADMIN: RoleString = "super_admin";
const TENANT_ADMIN: RoleString = "admin";

export function isSuperAdmin(role: RoleString): boolean {
  return role === SUPER_ADMIN;
}

export function isTenantAdmin(role: RoleString): boolean {
  return role === TENANT_ADMIN || role === SUPER_ADMIN;
}
